import { Button, Result } from 'antd';
import { FC } from 'react';

import { ReloadOutlined } from '@ant-design/icons';
import { getApiErrorMessage } from '@utils';

import { isMissingIncorporation } from './helpers';

type IncorporationLoadErrorProps = {
  error: unknown;
  onRetry: () => void;
};

/**
 * What an onboarding tab shows when the incorporation cannot be loaded and there is nothing
 * on screen to keep. Both Onboarding tabs used to fall through to their `Loader` instead, so
 * a company without onboarding data spun forever with no hint of why.
 *
 * A missing incorporation is a state, not a failure: it says so and offers no retry, since
 * retrying cannot change it.
 */
export const IncorporationLoadError: FC<IncorporationLoadErrorProps> = ({
  error,
  onRetry,
}) =>
  isMissingIncorporation(error) ? (
    <Result
      status="info"
      title="No onboarding data yet"
      subTitle="This company hasn’t passed KYB, so there is nothing to show here."
    />
  ) : (
    <Result
      status="warning"
      title="Couldn’t load onboarding data"
      subTitle={getApiErrorMessage(
        error,
        'The onboarding data failed to load. Please try again.'
      )}
      extra={
        <Button icon={<ReloadOutlined />} onClick={onRetry}>
          Try again
        </Button>
      }
    />
  );
